import { render, staticRenderFns } from "./Asesoria-en-siniestros.vue?vue&type=template&id=9254a4bc&scoped=true&"
import script from "./Asesoria-en-siniestros.vue?vue&type=script&lang=js&"
export * from "./Asesoria-en-siniestros.vue?vue&type=script&lang=js&"
import style0 from "./Asesoria-en-siniestros.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Asesoria-en-siniestros.vue?vue&type=style&index=1&id=9254a4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9254a4bc",
  null
  
)

export default component.exports